<div class="action-items-container">
  <div class="section-header">
    <emerald-icon icon="pending_actions" type="outlined"></emerald-icon>
    <div class="section-title">
      <h3>Action Items</h3>
      <span class="subtitle">Pending actions requiring attention</span>
    </div>
  </div>

  <div class="cards-row">
    <div class="action-card finance-card">
      <div class="card-icon">
        <emerald-icon icon="library_add_check" type="outlined"></emerald-icon>
      </div>
      <div class="card-body">
        <span class="card-title">Finance</span>
        <span class="card-value"
          >12 <span class="card-sub">(for the month of May)</span></span
        >
      </div>
    </div>

    <div class="action-card feedback-card" (click)="navigateToTeamComposition()">
      <div class="card-icon">
        <emerald-icon icon="rate_review" type="outlined"></emerald-icon>
      </div>
      <div class="card-body">
        <span class="card-title">Quarterly Feedback</span>
        <span class="card-value">{{ employeesWithFeedback }}/{{ totalReportess }}</span>
      </div>
    </div>

    <div class="action-card timesheet-card" (click)="navigateToTimesheet()">
      <div class="card-icon">
        <emerald-icon
          icon="pending_actions"
          type="outlined"
        ></emerald-icon>
      </div>
      <div class="card-body">
        <span class="card-title">{{ timesheetTitle }}</span>
        <span class="card-value" *ngIf="isTimesheetLoaded && submittedCount !== null">
          {{ approvedCount }}/{{ submittedCount }}
        </span>
      </div>
    </div>
  </div>
</div>

<app-modal-wrapper [showModal]="showTeamDetailsModal">
  <app-team-composition-details
    *ngIf="showTeamDetailsModal"
    [empId]="selectedProfileId"
    (close)="closeTeamDetailsModal()"
  ></app-team-composition-details>
</app-modal-wrapper>
